/*
  Provides UI for configuring a PDF export of a project.
  Currently this is just for orientation - but as we improve our PDF
  rendering, we could add options for page numbers, watermark, branding etc.
 */

(function () {
  module.exports = function (
    createUi,
    overlayStack,
    project,
    projectLinkRetriever,
    telemetry,
    Link,
    make,
    overlayOptions,
    $state,
  ) {
    var pdfUrl, pdfUrlLandscape, pdfUrlLandscapeLink, pdfUrlPortrait, pdfUrlPortraitLink, ui;
    pdfUrl = projectLinkRetriever.getPdfUrlForProject(project);
    pdfUrlPortrait = pdfUrl + "?orientation=portrait";
    pdfUrlLandscape = pdfUrl + "?orientation=landscape";
    ui = createUi(require("./PdfExport.html"), {
      export: function (orientation) {
        window.open(pdfUrl + ("?orientation=" + orientation));
        telemetry.trackOnly("Project Share PDF Downloaded", {
          pdf_orientation: orientation,
        });
        if (!(overlayOptions != null ? overlayOptions.keepOverlay : void 0)) {
          return overlayStack.closeCurrent();
        }
      },
    });
    pdfUrlPortraitLink = make(Link, {
      linkUrl: pdfUrlPortrait,
      options: {},
    });
    ui.pdfUrlPortraitLink = pdfUrlPortraitLink.ui;
    pdfUrlLandscapeLink = make(Link, {
      linkUrl: pdfUrlLandscape,
      options: {},
    });
    ui.pdfUrlLandscapeLink = pdfUrlLandscapeLink.ui;
    return overlayStack.add({
      contentUi: ui,
      options: overlayOptions,
    });
  };
}.call(this));
